import { render, staticRenderFns } from "./NewTeam.vue?vue&type=template&id=c2c4e1dc&scoped=true&"
import script from "./NewTeam.vue?vue&type=script&lang=js&"
export * from "./NewTeam.vue?vue&type=script&lang=js&"
import style0 from "./NewTeam.vue?vue&type=style&index=0&id=c2c4e1dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c4e1dc",
  null
  
)

export default component.exports